// @ts-check
import { Component } from "../engine";
import { EVENT_INGAME_EXPLOSION } from "../global";

export class GameVibrator extends Component {
    handleEvent(e) {
        if (navigator.vibrate && this.options.enabled !== false && e.type == EVENT_INGAME_EXPLOSION) {
            navigator.vibrate(100);
        }
    }
}
